import { useEffect, useState } from 'react';

export default function ReclamosDocumentacion({ solicitudes, carpetaFilter, onCarpetaFilter, docFilter, onDocFilter }) {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimated(true), 400);
    return () => clearTimeout(timer);
  }, []);

  // Carpeta armada
  // eslint-disable-next-line
  const carpetaSi = solicitudes.filter(d => d.docOffice == 1).length;
  const carpetaNo = solicitudes.filter(d => !d.docOffice || d.docOffice == 0).length; // eslint-disable-line
  const carpetaTotal = carpetaSi + carpetaNo || 1;
  const carpetaPct = ((carpetaSi / carpetaTotal) * 100).toFixed(0);

  // Estado documentación
  const docSin = solicitudes.filter(d => d.estadoDoc == 0 || d.estadoDoc === null || d.estadoDoc === undefined).length; // eslint-disable-line
  const docParcial = solicitudes.filter(d => d.estadoDoc == 1).length; // eslint-disable-line
  const docCompleta = solicitudes.filter(d => d.estadoDoc == 2).length; // eslint-disable-line
  const docTotal = solicitudes.length || 1;

  // SVG donut params
  const radius = 38;
  const circumference = 2 * Math.PI * radius;
  const siOffset = circumference - (carpetaSi / carpetaTotal) * circumference;

  return (
    <div className='dashboard-card reclamos-doc-card'>
      <div className='dashboard-card-header'>
        <span className='dashboard-card-title'>
          <i className='bi bi-folder-check'></i>
          Documentación
        </span>
      </div>

      {/* Carpeta armada section */}
      <div className='doc-section-title'>
        <i className='bi bi-folder2-open' style={{ color: '#10b981' }}></i>
        Carpetas Armadas
      </div>
      <div className='carpeta-visual'>
        <div className='carpeta-ring'>
          <svg width='100' height='100' viewBox='0 0 100 100'>
            <circle cx='50' cy='50' r={radius} fill='none' stroke='#e2e8f0' strokeWidth='10' />
            <circle
              cx='50' cy='50' r={radius}
              fill='none'
              stroke='#10b981'
              strokeWidth='10'
              strokeDasharray={circumference}
              strokeDashoffset={animated ? siOffset : circumference}
              strokeLinecap='round'
              style={{ transition: 'stroke-dashoffset 1.2s cubic-bezier(0.4, 0, 0.2, 1)' }}
            />
          </svg>
          <div className='carpeta-ring-label'>
            <div className='carpeta-ring-value'>{carpetaPct}%</div>
            <div className='carpeta-ring-text'>Armadas</div>
          </div>
        </div>
        <div className='carpeta-legend'>
          <div
            className={`carpeta-legend-item carpeta-legend-item--clickable ${carpetaFilter === 1 ? 'carpeta-legend-item--active' : ''}`}
            onClick={() => onCarpetaFilter(1)}
          >
            <span className='carpeta-legend-dot carpeta-legend-dot--si'></span>
            <span className='carpeta-legend-label'>Con carpeta</span>
            <span className='carpeta-legend-count'>{carpetaSi}</span>
          </div>
          <div
            className={`carpeta-legend-item carpeta-legend-item--clickable ${carpetaFilter === 0 ? 'carpeta-legend-item--active' : ''}`}
            onClick={() => onCarpetaFilter(0)}
          >
            <span className='carpeta-legend-dot carpeta-legend-dot--no'></span>
            <span className='carpeta-legend-label'>Sin carpeta</span>
            <span className='carpeta-legend-count'>{carpetaNo}</span>
          </div>
        </div>
      </div>

      <div className='doc-divider'></div>

      {/* Estado documentación section */}
      <div className='doc-section-title'>
        <i className='bi bi-file-earmark-text' style={{ color: '#3b82f6' }}></i>
        Estado de Documentación
      </div>
      <div className='doc-estado-rows'>
        <div
          className={`doc-estado-row doc-estado-row--clickable ${docFilter === 0 ? 'doc-estado-row--active' : ''}`}
          onClick={() => onDocFilter(0)}
        >
          <div className='doc-estado-header'>
            <span className='doc-estado-label'>
              <i className='bi bi-x-circle' style={{ color: '#94a3b8' }}></i>
              Sin Documentación
            </span>
            <span className='doc-estado-count'>{docSin}</span>
          </div>
          <div className='doc-estado-bar-bg'>
            <div
              className='doc-estado-bar-fill doc-estado-bar-fill--sin'
              style={{ width: animated ? `${(docSin / docTotal) * 100}%` : '0%' }}
            />
          </div>
        </div>

        <div
          className={`doc-estado-row doc-estado-row--clickable ${docFilter === 1 ? 'doc-estado-row--active' : ''}`}
          onClick={() => onDocFilter(1)}
        >
          <div className='doc-estado-header'>
            <span className='doc-estado-label'>
              <i className='bi bi-clock-history' style={{ color: '#d97706' }}></i>
              Carga Parcial
            </span>
            <span className='doc-estado-count'>{docParcial}</span>
          </div>
          <div className='doc-estado-bar-bg'>
            <div
              className='doc-estado-bar-fill doc-estado-bar-fill--parcial'
              style={{ width: animated ? `${(docParcial / docTotal) * 100}%` : '0%' }}
            />
          </div>
        </div>

        <div
          className={`doc-estado-row doc-estado-row--clickable ${docFilter === 2 ? 'doc-estado-row--active' : ''}`}
          onClick={() => onDocFilter(2)}
        >
          <div className='doc-estado-header'>
            <span className='doc-estado-label'>
              <i className='bi bi-check-circle' style={{ color: '#059669' }}></i>
              Documentación Completa
            </span>
            <span className='doc-estado-count'>{docCompleta}</span>
          </div>
          <div className='doc-estado-bar-bg'>
            <div
              className='doc-estado-bar-fill doc-estado-bar-fill--completa'
              style={{ width: animated ? `${(docCompleta / docTotal) * 100}%` : '0%' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
